var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ModalFullScreen", {
        attrs: {
          title: _vm.modalTitle,
          size: "xl",
          showCustomTitle: _vm.isEdittingLocked,
          static: true,
        },
        on: { close: _vm.closeModal },
        scopedSlots: _vm._u(
          [
            {
              key: "titleLine",
              fn: function () {
                return [_vm._t("customHeader", null, { title: _vm.modalTitle })]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return [
                  _c(
                    "form",
                    [
                      _c("ValidationObserver", {
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ invalid, handleSubmit }) {
                              return [
                                _c(
                                  "ModalContent",
                                  {
                                    scopedSlots: _vm._u(
                                      [
                                        !_vm.show
                                          ? {
                                              key: "actions",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex ml-auto",
                                                    },
                                                    [
                                                      _c("UiButton", {
                                                        staticClass: "mr-3",
                                                        attrs: {
                                                          id: "savebutton2",
                                                          disabled:
                                                            invalid ||
                                                            _vm.isEdittingLocked,
                                                          variant: "secondary",
                                                          buttonText: "Save",
                                                          processing:
                                                            _vm.processing,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return handleSubmit(
                                                              _vm.onUpdate
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            }
                                          : null,
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "grid grid-cols-4 gap-4" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "col-span-2" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "row-span-full" },
                                              [
                                                _c(
                                                  "FormGroup",
                                                  { attrs: { title: "Type" } },
                                                  [
                                                    _c("TagMultiselect", {
                                                      staticClass: "mb-5",
                                                      attrs: {
                                                        selectedTagId:
                                                          _vm.selectedTagNewValue,
                                                      },
                                                      on: {
                                                        input:
                                                          _vm.selectedTagNewValueFunc,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row-span-full mt-4",
                                              },
                                              [
                                                _c(
                                                  "FormGroup",
                                                  {
                                                    attrs: { title: "Source" },
                                                  },
                                                  [
                                                    _c("SourcesMultiselect", {
                                                      staticClass: "mb-5",
                                                      attrs: {
                                                        selectedSourceId:
                                                          _vm.selectedappliedSourceNewValue,
                                                      },
                                                      on: {
                                                        input:
                                                          _vm.selectedappliedSourceNewValueFunc,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row-span-full mt-4",
                                              },
                                              [
                                                _c(
                                                  "ValidationProvider",
                                                  {
                                                    attrs: {
                                                      name: "Profile link",
                                                    },
                                                  },
                                                  [
                                                    _c("FormGroup", {
                                                      attrs: {
                                                        title: "Profile Link",
                                                        name: "profileLink",
                                                        placeholder:
                                                          "Link to profile on sourcing platform",
                                                        type: "text",
                                                        inputClasses: "pl-7",
                                                        disabled:
                                                          _vm.isEdittingLocked,
                                                      },
                                                      model: {
                                                        value: _vm.profilelinkp,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.profilelinkp = $$v
                                                        },
                                                        expression:
                                                          "profilelinkp",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row-span-full mt-4",
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "mb-2" },
                                                  [_vm._v("Duration")]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "flex" },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "mt-2 mr-2",
                                                      },
                                                      [_vm._v("from")]
                                                    ),
                                                    _c("ValidationProvider", {
                                                      attrs: {
                                                        rules: "required_field",
                                                        vid: "start_date",
                                                        name: "Start date",
                                                        immediate:
                                                          !!_vm.projectActivity,
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function ({
                                                              errors,
                                                              failed,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "FormGroup",
                                                                  {
                                                                    attrs: {
                                                                      errors:
                                                                        errors,
                                                                      name: "start_date",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "FormDatepicker",
                                                                      {
                                                                        attrs: {
                                                                          calendarClass:
                                                                            "bottom-11",
                                                                          invalid:
                                                                            failed,
                                                                          disabled:
                                                                            _vm.isEdittingLocked,
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.fromdatep,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.fromdatep =
                                                                                $$v
                                                                            },
                                                                          expression:
                                                                            "fromdatep",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "mt-2 mr-2 ml-2",
                                                      },
                                                      [_vm._v("till")]
                                                    ),
                                                    _c("ValidationProvider", {
                                                      attrs: {
                                                        rules:
                                                          "noBeforeDate:@start_date,@ongoing|required_field",
                                                        vid: "end_date",
                                                        name: "End Date",
                                                        immediate:
                                                          !!_vm.projectActivity,
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function ({
                                                              errors,
                                                              failed,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "FormGroup",
                                                                  {
                                                                    attrs: {
                                                                      errors:
                                                                        errors,
                                                                      name: "end_date",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "FormDatepicker",
                                                                      {
                                                                        attrs: {
                                                                          calendarClass:
                                                                            "right-0 bottom-11",
                                                                          invalid:
                                                                            failed,
                                                                          disabled:
                                                                            _vm.isEdittingLocked,
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.todatep,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.todatep =
                                                                                $$v
                                                                            },
                                                                          expression:
                                                                            "todatep",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row-span-full mt-6 flex",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  [
                                                    _c("Checkbox", {
                                                      attrs: {
                                                        id: _vm
                                                          .showAvailabilityCheckbox
                                                          .id,
                                                        name: _vm
                                                          .showAvailabilityCheckbox
                                                          .name,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .showAvailabilityCheckbox
                                                            .selected,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.showAvailabilityCheckbox,
                                                            "selected",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "showAvailabilityCheckbox.selected",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "col-span-2" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "row-span-full" },
                                              [
                                                _c("ValidationProvider", {
                                                  attrs: {
                                                    name: "title",
                                                    rules: "required",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function ({
                                                          errors,
                                                          failed,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "FormGroup",
                                                              {
                                                                attrs: {
                                                                  id: "title",
                                                                  title: "Rate",
                                                                  name: "type",
                                                                  placeholder:
                                                                    "Contractor's rate",
                                                                  disabled:
                                                                    _vm.isEdittingLocked,
                                                                  errors:
                                                                    errors,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "FormInputGroup",
                                                                  {
                                                                    attrs: {
                                                                      invalid:
                                                                        failed,
                                                                      inputClasses:
                                                                        "pl-7",
                                                                      type: "number",
                                                                      prefix:
                                                                        "$",
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.ratesp,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.ratesp =
                                                                            $$v
                                                                        },
                                                                      expression:
                                                                        "ratesp",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "row-span-6 mt-4",
                                              },
                                              [
                                                _c(
                                                  "FormGroup",
                                                  { attrs: { title: "Notes" } },
                                                  [
                                                    _c("FormTextarea", {
                                                      attrs: {
                                                        rows: 10,
                                                        placeholder:
                                                          "Additional details",
                                                        disabled:
                                                          _vm.isEdittingLocked,
                                                      },
                                                      model: {
                                                        value: _vm.notesp,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.notesp = $$v
                                                        },
                                                        expression: "notesp",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }